import { type ISearchService } from "@/lib/depict-client/interfaces/ISearchService"
import { type IListingService } from "@/lib/depict-client/interfaces/IListingService"
import { type IRecommendationsService } from "@/lib/depict-client/interfaces/IRecommendationsService"
import { type IOtherService } from "@/lib/depict-client/interfaces/IOtherService"

export class DepictClient {
    constructor(
        public search: ISearchService,
        public listing: IListingService,
        public recommendations: IRecommendationsService,
        public other: IOtherService
    ) {}
}
